import { controls } from "../../controls";
const rprbi23 = {
  label: "NRLM",
  starting: true,
  url: "NRLM",
  pageLabel: "NRLM",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.magicDateLabel({ tab: "filter", label: "From Date", width: "col-sm-2", target: "from_date" }),
    ...controls.magicDate({ tab: "filter", name: "from_date", width: "col-sm-2", dateType: "ontype", default: "sd" }),

    ...controls.magicDateLabel({ tab: "filter", label: "As on Date", width: "col-sm-2", target: "as_on_date" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", default: "sd" }),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "RBI NRLM",
    filterable: true,
    sortable: true,
    pdfProps: { pageSize: "A3", pageOrientation: "landscape" },

    textReportProps: {
      'LBS': {
        filename: `RBI-NRLM-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },
    defaultsTo: 0,

    displayColumns: [
      {
        Header: "Branch Code",
        accessor: "branch_code",
      },
      {
        Header: "Branch Name",
        accessor: "branch_display",
      },
      {
        Header: "SHG No.",
        accessor: "quarter_cnt",
      },
      {
        Header: "SHG Amount",
        accessor: "disbursed_amt",
      },
    ]
  }
};
export default rprbi23;